<template>
  <div>
    <b-modal
      id="modal-prevent-closing"
      ref="ExportCsvModal"
      title="Exportação CSV"
      size="lg"
      @hide="onModalHide"
    >
      <b-row v-if="!isExport">
        <b-col cols="8">
          <div v-for="field in fields" :key="field.label">
            <label for="" class="mt-3">{{ field.label }}</label>
            <workflow-filter
              class="filters"
              :labelName="field.label"
              :fieldType="field.type"
              :fieldId="field.fieldId"
              :filter="getFilter(field)"
              :dateOpt.sync="
                fields[getFieldIndex(field.label)].optionFilterDate
              "
              :filterApplied="filterApplied"
            ></workflow-filter>
          </div>
          <label for="perPage">Quantidade</label>
          <b-form-select
            v-model="paramsPg.perPage"
            id="perPage"
            :options="tablePageOptions"
          ></b-form-select>
        </b-col>
      </b-row>
      <div v-if="isExport">
        <div class="text-center my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Exportando...</strong>
        </div>
      </div>
      <template #modal-footer="{}">
        <div class="right">
          <b-button
            class="ml-2"
            :disabled="isExport"
            variant="green"
            @click="exportCsv()"
          >
            Iniciar Exportação
          </b-button>
          <b-button class="ml-2" variant="danger" @click="cancel()">
            {{ $t("geral.cancel") }}
          </b-button>
        </div>
      </template>
    </b-modal>
    <base-dialog-confirm
      ref="confirm"
      @confirm="hideModal"
      :message="'Deseja cancelar a exportação?'"
      :title="'Cancelar exportação'"
    >
    </base-dialog-confirm>
  </div>
</template>

<script>
export default {
  name: "WorkflowExportCsvModal",
  props: {
    processId: String,
    tableFilters: Object,
    fields: Array,
  },
  components: {
    WorkflowFilter: () =>
      import("@/components_rms/workflow/WorkflowFilled/WorkflowFilter.vue"),
    "base-dialog-confirm": () =>
      import("@/components_rms/base/BaseDialogConfirm.vue"),
  },
  data() {
    return {
      isExport: false,
      paramsPg: {
        processFilledId: "",
        fillDateBegin: "",
        fillDateEnd: "",
        fillUserName: "",
        currentPage: 1,
        perPage: 10,
        values: {},
      },
      abortController: null,
      tablePageOptions: [5, 10, 25, 50, 100, 150, 200, 300, 400, 500, 600, 700, 800, 900, 1000],
    };
  },
  methods: {
    getFilter(field) {
      for (let filter of this.tableFilters.fields) {
        if (filter.label == field.label) {
          return filter;
        }
      }
      return null;
    },
    getFieldIndex(label) {
      for (let i = 0; i < this.fields.length; i++) {
        let field = this.fields[i];
        if (field.label == label) {
          return i;
        }
      }
      return 0;
    },
    openModal() {
      this.$refs.ExportCsvModal.show();
    },
    hideModal() {
      if (this.abortController) {
        this.abortController.abort();
        this.abortController = null;
        this.isExport = false;
      }
      this.$refs.ExportCsvModal.hide();
    },
    onModalHide() {
      if (this.abortController != null) {
        this.$refs.confirm.show();
      } else {
        this.$refs.ExportCsvModal.hide();
      }
    },
    cancel() {
      if (this.abortController) {
        this.abortController.abort();
        this.abortController = null;
        this.isExport = false;
      } else {
        this.$refs.ExportCsvModal.hide();
      }
    },
    exportCsv() {
      this.isExport = true;
      this.$forceUpdate();

      this.paramsPg.values = this.tableFilters.fields;
      this.abortController = new AbortController();
      this.$apiWorkflow
        .request({
          url: "/processFilled/export/csv/" + this.processId,
          method: "POST",
          data: this.paramsPg,
          responseType: "arraybuffer", //important
          signal: this.abortController.signal,
        })
        .then((response) => {
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers["content-type"],
            })
          );
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", response.headers["filename"]);
          document.body.appendChild(link);
          link.click();
          link.remove();
          this.isExport = false;
          this.abortController = null;
        });
    },
  },
};
</script>

<style scoped>
.right {
  text-align: right;
  width: 100%;
}
</style>